import { BASE_API_URL } from "../constants/apiEndpoints";
import { getFetch } from "./apiClient";
import { logger } from "../utils/logger";

/*
未読件数対応:
対応日: 2026/04/12
担当者: 越智
修正概要: 取得条件をタスク一覧と合わせる
*/
export const getUnreadCount = async (userType, userId, identifyId, roleId) => {
  /*
END
未読件数対応:
*/
  /*
  課題・障害番号: なし
  対応日: 2026/4/7
  担当者: 影山
  修正概要: ESLint対応 let -> const
  */
  const user = userId;
  /*
  END
  課題・障害番号: なし
  */

  /*
  未読件数対応:
  対応日: 2026/04/12
  担当者: 越智
  修正概要: 取得条件をタスク一覧と合わせる
  */
  const requestUrl = `${BASE_API_URL}/task/unreadCount?type=${userType}&user=${user}&identify_id=${identifyId}&role_id=${roleId}`;
  /*
  END
  未読件数対応:
  */

  try {
    const response = await getFetch(requestUrl);

    if (!response.ok) {
      const errorBody = await response.json().catch(() => {});
      const message = errorBody?.message || `APIリクエスト失敗。status：${response.status}`;
      throw new Error(message);
    }

    const result = await response.json();

    // 結果がnullやundefinedでないかチェック
    // バックエンド側が result.rows || [] で返しているため、基本は配列が届く想定
    const detailData = result;

    if (!detailData) {
      throw new Error("対象のデータが見つかりませんでした。");
    }

    return detailData;
  } catch (error) {
    logger.error("Get UserList API Detail Error:", error);
    throw error;
  }
};
